<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2023-09-11 08:57:14
 * @LastEditTime : 2024-10-25 14:11:26
 * @LastEditors  : yangxr
 * @Description  : 皮重任务
 * @FilePath     : \icps_fb\src\views\platform\ICPS\smart\schedul\tareTask.vue
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main>
        <div>
          <div class="search">
            <span style="display: inline-block; margin-bottom: 10px">
              <span style="margin-right: 12px">车牌号</span>
              <el-input v-model="tableParam.carNo" style="width: 150px" clearable placeholder="请输入" @keyup.enter.native="gettableData()" />
            </span>
            <span style="margin-left: 24px">
              <span style="margin-right: 12px">站点名称</span>
              <el-input v-model="tableParam.stationName" style="width: 20%; max-width: 150px" clearable placeholder="请输入" @keyup.enter.native="gettableData()" />
            </span>
            <span style="margin-left: 24px">
                  <span style="margin-right: 12px">重量干预</span>
                  <el-select ref="selection" v-model="tableParam.weightIntervention" style="width: 100px" clearable>
                    <el-option :key="0" label="否" :value="0"></el-option>
                    <el-option :key="1" label="是" :value="1"></el-option>
                  </el-select>
                </span>
            <span style="margin-left: 24px">
                  <span style="margin-right: 12px">创建时间</span>
                  <el-date-picker v-model="startTimDateEndTimDate1" type="datetimerange" unlink-panels
                  style="width:340px"
                    value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始时间" end-placeholder="结束时间"
                    @change="(tableParam.createTime = startTimDateEndTimDate1 ? startTimDateEndTimDate1[0] : ''), (tableParam.updateTime = startTimDateEndTimDate1 ? startTimDateEndTimDate1[1] : '')"></el-date-picker>
                </span>
                <span style="margin-left: 24px">
                  <span style="margin-right: 12px">过磅时间</span>
                  <el-date-picker v-model="startTimDateEndTimDate2" type="datetimerange" unlink-panels
                  style="width:340px"
                    value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始时间" end-placeholder="结束时间"
                    @change="(tableParam.weightTime = startTimDateEndTimDate2 ? startTimDateEndTimDate2[0] : ''), (tableParam.endTime = startTimDateEndTimDate2 ? startTimDateEndTimDate2[1] : '')"></el-date-picker>
                </span>
            <el-button icon="el-icon-search" size="medium" class="bottom_all but1" @click="(tableParam.page = 1), gettableData()">查 询</el-button>
            <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
            <el-button size="medium" class="bottom_three" style="margin-left: 12px" @click="load()">导 出</el-button>
          </div>
        </div>
        <div class="hr"></div>
        <div class="card">
          <div class="card_nav">
            <div>
              <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'TIANJIA') !== -1" size="small" class="bottom_all" style="margin-left: 0" @click="addFromDate('添加'), (disabledType = false,checked1 = false)">
                <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
                添加
              </el-button>
            </div>
            <div>
              <el-dropdown :hide-on-click="false" trigger="click" style="margin: 0 20px">
                <el-link :underline="false">
                  <span class="el-icon--left">
                    <i class="iconfont iconicon_button_filtrate"></i>
                  </span>
                  筛选
                </el-link>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(item, index) in table" :key="index">
                    <el-checkbox v-model="item.status">{{ item.label }}</el-checkbox>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div v-loading="tableLoading" class="card_info" :style="style">
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="tableData" tooltip-effect="dark">
              <template v-for="(item, index2) in table">
                <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center" :width="item.width">
                  <template slot-scope="scope">
                    <div v-if="item.label == '过磅照片'">
                      <el-button size="mini" class="bottom_one" @click="look1Fun(scope.row)">查看</el-button>
                    </div>
                    <div v-else-if="item.label == '操作'">
                      <!-- <el-button size="mini" class="bottom_one" @click="updateFromDate(scope.row, '修改'), (disabledType = false)">修改</el-button> -->
                      <el-button size="mini" class="bottom_two" style="margin-left: 10px" @click="deleteTask(scope.row.id)"> 删除 </el-button>
                    </div>
                    <span v-else>{{ scope.row[item.prop] }}</span>
                  </template>
                </el-table-column>
              </template>
            </el-table>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination
            :current-page.sync="tableParam.page"
            :page-size="tableParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]"
            layout="prev,pager,sizes,next,jumper"
            :total="total"
            @size-change="sizeChange"
            @current-change="gettableData()"
          ></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
        </div>
      </div>
    </el-container>
    <el-dialog v-dialogDrag :visible.sync="addDialog" width="580px" :close-on-click-modal="false" :before-close="resetFromDate">
      <span slot="title" class="dialog-title">{{ addDialogTitle }}</span>
      <div class="dialoginfo">
        <el-form ref="reffromDate" :inline="true" :model="fromDate" label-width="110px" :disabled="disabledType" hide-required-asterisk>
          <el-form-item prop="stationId" :rules="[{ required: true, message: '请选择站点', trigger: 'change' }]">
            <span slot="label" style="color: #ff0000">站点</span>
            <el-select
              ref="selection2"
              v-model="fromDate.stationId"
              placeholder="请选择"
              filterable
              @change="
              getCarList(),
                $nextTick(() => {
                  fromDate.stationName = $refs.selection2.selectedLabel;
                })
              "
            >
              <el-option v-for="(item, index) in stationIdlist" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="carNoList" :rules="[{ required: true, message: '请选择车牌号', trigger: 'change' }]">
            <span slot="label" style="color: #ff0000">车牌号</span>
            <el-select
              v-model="fromDate.carNoList"
              placeholder="请选择"
              multiple
              filterable
              clearable
            >
            <el-checkbox v-model="checked1" style="padding-left: 10px; height: 34px; line-height: 34px" @change="selectAll1">全选</el-checkbox>
              <el-option v-for="(item, index) in carList" :key="index" :label="item" :value="item"></el-option>
            </el-select>
            <!-- <el-input v-model="fromDate.carNo" placeholder="请输入" clearable></el-input> -->
          </el-form-item>
          <el-form-item>
            <span slot="label">备注信息</span>
            <el-input v-model="fromDate.remark" :rows="5" resize="none" style="width: 320px" type="textarea" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <span slot="label">是否补单</span>
            <el-radio-group v-model="fromDate.supplementaryOrdersStatus">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <span style="margin-left: 40px">补单仅用作无人值守异常任务关联，正常任务则为否。</span>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button v-show="disabledType" class="bottom_all_two" @click="resetFromDate">关 闭</el-button>
        <el-button v-show="!disabledType" class="bottom_all_two" @click="resetFromDate">取 消</el-button>
        <el-button v-show="!disabledType" :disabled="submitLoading" class="bottom_all" style="margin-left: 24px" @click="submit()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 查看照片 -->
    <el-dialog v-dialogDrag :visible.sync="look1Type" width="740px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">图片预览</span>
      <div class="dialoginfo">
        <div class="FZYimgMp4list">
          <div v-for="(v, k) in urlList" :key="k">
            <el-image
              :src="'/file/' + v"
              :preview-src-list="srcList"
              style="width: 200px; height: 200px; margin: 5px 10px; box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.35)"
              :z-index="10000"
              @click="srcList = ['/file/' + v]"
            ></el-image>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="look1Type = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import { queryPage, saveOrUpdate, deleteTareTask, queryCarNoByStation,Download } from "@/api/smart/schedul/tareTask.js";
import { post } from "@/api/table.js";
import { getUserAutList } from "@/api/common.js";
export default {
  mixins: [mixin],
  data() {
    return {
      disabledType: false,
      /*表格增删改查及下载接口*/
      DownloadURL: Download,
      queryPage: queryPage,
      saveOrUpdate: saveOrUpdate,
      loading: false,
      /*表格数据*/
      table: [
        {
          label: "任务编号",
          width: "",
          prop: "id",
          status: true,
        },
        {
          label: "车牌号",
          width: "",
          prop: "carNo",
          status: true,
        },
        {
          label: "站点名称",
          width: "",
          prop: "stationName",
          status: true,
        },
        {
          label: "备注",
          width: "",
          prop: "remark",
          status: true,
        },
        {
          label: "创建时间",
          width: "",
          prop: "createTime",
          status: true,
        },
        {
          label: "过磅时间",
          width: "",
          prop: "weightTime",
          status: true,
        },
        {
          label: "过磅量（吨）",
          width: "",
          prop: "currentTareWeight",
          status: true,
        },
        {
          label: "过磅照片",
          width: "",
          prop: "",
          status: true,
        },
        {
          label: "操作",
          width: "160",
          prop: "",
          status: true,
        },
      ],
      /*表单页类型，0为无树状，1为有树状，有树状在el-main加上display:flex*/
      pagesType: 0,
      /*添加表单数据*/
      fromDate: {
        carNoList: "",
        stationId: "",
        stationName: "",
        remark: "",
        supplementaryOrdersStatus: 0,
      },
      stationIdlist: [],
      look1Type: false,
      urlList: [],
      srcList: [],
      carList:[],
      checked1:false,
      startTimDateEndTimDate1:[],
      startTimDateEndTimDate2:[],
    };
  },
  async created() {
    this.stationIdlist = await getUserAutList(true);
    /*存储拷贝的原初始化fromDate数据*/
    this.tableParam = { ...this.tableParam, dataSource: 1, carNo: "", stationName: "" ,weightIntervention:"",};
    this.gettableData();
  },
  methods: {
    selectAll1() {
      if (this.checked1) {
        this.fromDate.carNoList = this.carList.map(item => item);
      } else {
        this.fromDate.carNoList = [];
      }
    },
    getCarList(){
      queryCarNoByStation({stationId:this.fromDate.stationId}).then(res => {
        if(res.code == 1001) {
          this.carList = res.data
        }
      })
    },
    look1Fun(e) {
      this.look1Type = true;
      this.urlList = e.pictureUrl ? e.pictureUrl.split(",") : [];
      console.log(this.urlList)
    },
    deleteTask(id) {
      this.$confirm("此操作将永久删除该信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => {
          deleteTareTask({ id: id }).then(res => {
            if (res.code == 1001) {
              this.gettableData();
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
          });
        })
        .catch(() => {});
    },
    init() {
      /*重置数据*/
      this.tableParam.carNo = "";
      this.tableParam.weightIntervention = "";
      this.tableParam.stationName = "";
      this.tableParam.createTime = "";
      this.tableParam.updateTime = "";
      this.tableParam.weightTime = "";
      this.tableParam.endTime = "";
      this.startTimDateEndTimDate1 = []
      this.startTimDateEndTimDate2 = []
      this.gettableData();
    },
    submit() {
      let _this = this;
      _this.$refs.reffromDate.validate(valid => {
        if (valid) {
          _this.submitFromDate();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    Delete(row) {
      this.$confirm("此操作将删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      }).then(() => {
        let json = {
          id: row.id,
          status: 0,
        };
        post(this.saveOrUpdate, json).then(res => {
          this.loading = false;
          this.submitLoading = false;
          if (res.code === 1001) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.gettableData();
          }
        });
      });
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
  },
};
</script>

<style lang="scss" scoped>
.table_top {
  color: #008000;
}
.table_top:hover {
  color: #008000 !important;
  opacity: 0.8;
}
.el-input,
.el-select {
  width: 320px;
}
.table_link {
  margin-left: 10px;
  color: $bg_color;
}
.table_link:hover {
  opacity: 0.8;
}
.dialoginfo-title {
  > div {
    cursor: pointer;
  }
  height: 48px;
  display: flex;
  background: linear-gradient(180deg, rgba(250, 252, 255, 1) 0%, rgba(245, 247, 250, 1) 100%);
  .none {
    font-weight: bold;
    height: 48px;
    @include discen;
    width: calc(100% / 2);
    border-bottom: 1px solid #e1e5ed;
    > div {
      line-height: 48px;
      border-bottom: 1px rgba(0, 0, 0, 0) solid;
    }
  }
  .active {
    font-weight: bold;
    height: 48px;
    @include discen;
    width: calc(100% / 2);
    border: 1px solid #e1e5ed;
    border-bottom: 0;
    background: #ffffff;
    > div {
      color: $bg_color;
      line-height: 48px;
      border-bottom: 1px $bg_color solid;
    }
  }
}
.no-data {
  text-align: center;
}
.FZY ::v-deep .el-input-group__append {
  padding: 0px 8px;
}
.FZYimgMp4list {
  display: flex;
  flex-wrap: wrap;
}
</style>